function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { Consumer } from './scrollContext';

var SectionLink = function SectionLink(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Consumer, null, function (_ref2) {
    var refList = _ref2.refList,
        selected = _ref2.selected,
        scrollTo = _ref2.scrollTo;
    var allLinks = Object.keys(refList).reduce(function (acc, curr) {
      var _extends2;

      return _extends(_extends({}, acc), {}, (_extends2 = {}, _extends2[curr] = {
        onClick: function onClick() {
          return scrollTo(curr);
        },
        isSelected: selected === curr
      }, _extends2));
    }, {});
    return children({
      allLinks: allLinks
    });
  });
};

export default SectionLink;